<template>
  <div>
    <div class="columns">
      <div class="column is-12">
        <router-link :to="{ path: '/inicio' }" class="logo-footer">
          <img
            src="~@/assets/images/logo-footer-1.png"
            alt="Rede SARAH de Hospitais de Reabilitação - Associação das Pioneiras Sociais"
          />
        </router-link>
      </div>
    </div>
    <div class="menu-footer-container">
      <div class="columns">
        <b-menu class="column is-3" />
        <div class="column is-9">
          <ul class="units">
            <li v-for="unit in units" :key="unit.name">
              <strong>{{ unit.name }}</strong>
              <span>{{ unit.phone }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="menu-footer-more-info">
      <address style="cursor: pointer" @click="abrirTermoDeResponsabilidade">
        Política de Privacidade
      </address>
      <address>
        Rede SARAH | {{ ano }}<span>® Todos os direitos reservados</span>
      </address>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MenuFooter',

  data() {
    return {
      openInput: false,
      units: [
        { name: 'SARAH - Belém', phone: '(91) 3205-6700' },
        { name: 'SARAH - Belo Horizonte', phone: '(31) 3379-2600' },
        { name: 'SARAH - Brasília', phone: '(61) 3319-1111' },
        { name: 'SARAH - Lago Norte', phone: '(61) 3319-1111' },
        { name: 'SARAH - Fortaleza', phone: '(85) 3499-4999' },
        { name: 'SARAH - Macapá', phone: '(96) 3312-7000' },
        { name: 'SARAH - Rio de Janeiro', phone: '(21) 3543 7000' },
        { name: 'SARAH - Salvador', phone: '(71) 3206-3333' },
        { name: 'SARAH - São Luís', phone: '(98) 3216-5353' }
      ]
    }
  },

  computed: {
    ano() {
      return new Date().getFullYear()
    }
  },
  methods: {
    abrirTermoDeResponsabilidade() {
      window.open(
        'https://www.sarah.br/a-rede-sarah/politica-de-privacidade/',
        '_blank'
      )
    }
  },
  mounted() {}
}
</script>
<style lang="scss" scoped>
@import '~buefy/dist/buefy.css';
@import '~@/assets/stylesheets/styleguide';
.menu {
  .menu-label {
    color: var(--white);
    font-size: 1.15rem;
    font-weight: 400;
    border-bottom: 2px solid $neutral-color-2;
    margin-bottom: 0.5rem;
    line-height: 1.4;
  }
  a {
    color: var(--white);
    display: block;
    width: 100%;
    font-size: 0.9rem;
    padding-left: 0;
    &:hover {
      background: transparent;
      text-decoration: underline;
    }
  }
}
.logo-footer {
  max-width: 6.375rem;
  display: block;
  padding-left: 1rem;
  img {
    float: left;
  }
}
.menu-footer-container {
  padding: 1.125rem 0;
  border-top: 1px solid $gray-600;
  border-bottom: 1px solid $gray-600;
  border-color: var(--gray-600);
  .menu {
    a {
      padding-top: 0;
      padding-bottom: 1.5625rem;
      padding-left: 1rem;
    }
  }
  .units {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    li {
      width: 9.125rem;
      font-size: 0.75rem;

      color: var(--white);
      margin-bottom: 1.2rem;
      strong {
        color: var(--white);
        font-weight: 500;
      }
      span {
        font-size: 0.75rem;
        display: block;
      }
    }
  }
}
address {
  float: right;

  color: var(--white);
  font-size: 0.75rem;
  padding-top: 0.9375rem;
  span {
    padding-left: 0.6rem;
  }
}
.menu-footer-more-info {
  display: flex;
  justify-content: space-between;
}
</style>
